var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('y-chip',{attrs:{"label":_vm.getStatus,"color":_vm.getStatusColor}})}
var staticRenderFns = []

export { render, staticRenderFns }